export default __webpack_public_path__ + "static/media/kitchen3-afterB-1440w.3b748c8e.webp";